/**
 * Magyar telefonszámok formázása
 * @author Bálint Ádám
 */
export default function (app) {
	app.directive('phoneNumber', function () {
		return {
			scope: {
				phoneNumberValue: '=',
				onlyHungarian: '='
			},
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {

				scope.$watch('phoneNumberValue', function (newValue, oldValue) {

					if (!newValue && oldValue && !attrs.notRequired) {
						scope.phoneNumberValue = '+36 ';
					} else if (newValue == '+36' && oldValue == '+3' || newValue == '+36 1' && (oldValue == '+36 ' || oldValue == '+36') || /^\+36 \d\d$/.test(newValue) && /^\+36 \d$/.test(oldValue) || /^\+36 1 \d{3}$/.test(newValue) && /^\+36 1 \d{2}$/.test(oldValue) || /^\+36 \d{2} \d{3}$/.test(newValue) && /^\+36 \d{2} \d{2}$/.test(oldValue)) {
						scope.phoneNumberValue += ' ';
					} else if (oldValue == newValue + ' ') {
						scope.phoneNumberValue = newValue.slice(0, -1);
					}
					if (newValue && scope.onlyHungarian && !attrs.notRequired) {
						if (newValue.length < 3 || !/^\+36.*/.test(newValue)) {
							scope.phoneNumberValue = '+36 ';
						}
					}
					if (scope.onlyHungarian) {
						var isHungarianPhoneNumberValid = /^\+36[ ]{0,1}\d{2}[ ]{0,1}\d{3}[ ]{0,1}\d{4}$/.test(scope.phoneNumberValue);
						ctrl.$setValidity('hunPhoneFormat', isHungarianPhoneNumberValid);
					} else {
						var isPhoneNumberValid = /^\+[\d\s]*$/.test(scope.phoneNumberValue);
						ctrl.$setValidity('notValid', isPhoneNumberValid);
					}

					if (attrs.notRequired) {
						// Ha nem required a mező akkor nem validálunk üres tartalom esetén
						ctrl.$setValidity('notValid', true);
						ctrl.$setValidity('hunPhoneFormat', true);
					}
				});
				if (scope.onlyHungarian && scope.phoneNumberValue == '' && !attrs.notRequired) {
					scope.phoneNumberValue = '+36 ';
				}
				elem.focus(function () {
					var input = this;
					setTimeout(function () {
						input.selectionStart = input.selectionEnd;
					}, 1);
				});

			}
		};
	});
};
